import { Create } from 'react-admin'

import UserCreditsForm from './UserCreditsForm'

const UserCreditsCreate = props => {
  const transform = data => {
    if (data.preset) {
      delete data.preset
    }
    return data
  }
  return (
    <Create redirect="list" {...props} transform={transform} redirect="list">
      <UserCreditsForm />
    </Create>
  )
}

export default UserCreditsCreate
